import { extractDomainName } from './utils/helpers'
// @ts-ignore
import PlaceHolderImage from './images/user_profile_placeholder.png'
const STATIC_IMAGES = {
	PLACEHOLDER: PlaceHolderImage,
}
const LINK_CONSTANTS = {
	// It is use as a fallback value
	DEFAULT_AUTODESK_PROFILE_ACCOUNT: 'https://profile.autodesk.com/personalinfo',
	AUTODESK_PROFILE_ACCOUNT_DOMAIN: (url?: string) =>
		extractDomainName(url ?? ''),
}

const INFO_MESSAGES = {
	marketing: {
		DISCLAIMER: '',
	},
}

const ONBOARDED_SOURCES = {
	ACC: 'ACC',
}
const SELECTION_LIST_KEYS = {
	JOB_TITLES: 'jobTitles',
	COMPANY_TYPES: 'companyTypes',
}
export {
	STATIC_IMAGES,
	LINK_CONSTANTS,
	ONBOARDED_SOURCES,
	INFO_MESSAGES,
	SELECTION_LIST_KEYS,
}
